import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const TASK_CREATE_TASK: BuiltInTaskDefinition = {
    slug: 'task-create',
    name: 'Create a task from a conversation',
    kind: 'llm',
    overlapPolicy: 'skip',
    concurrencySafe: true,
    serializeOn: null,
    builtInRole: 'org_change',
    chatPurpose: 'create_task',
    goal: 'Design a new kind of job a member runs from now on (a task definition), write it as a plan, and get the CEO’s sign-off; the OS creates it at their approval. Never a piece of work to do once',
    metric: {
        text: 'Share of task-creation conversations that reach CEO sign-off without a human re-explaining the request',
    },
    guardrails: [
        'Propose only — write the plan with os.write_plan; the OS creates the task once the CEO approves',
        'A piece of work to do once is not a task: name the existing task that does it and end, without asking the CEO',
        'Reuse an existing role before inventing a new one, and give the task to a role, never a team',
        'Only propose built-in tools os.list_built_in_tools lists, and vendor tools already bound to this enterprise',
        'A request spanning more than one task proposes the whole flow as one plan',
        'Do not widen scope beyond what the CEO asked for',
    ],
    inputs: [
        {
            key: 'request',
            label: 'What the CEO wants',
            type: 'string',
            required: true,
        },
        {
            key: 'ceoNote',
            label: 'CEO note from a previous round',
            type: 'string',
            required: false,
        },
        {
            key: 'chatSessionId',
            label: 'Chat session this plan belongs to (chat fills it)',
            type: 'string',
            required: false,
        },
        {
            key: 'planKey',
            label: 'The conversation this plan belongs to when it has no chat session (the OS fills it)',
            type: 'string',
            required: false,
        },
    ],
    tools: [
        'os.directory',
        'os.list_tool_bindings',
        'os.list_built_in_tools',
        'os.read_task',
        'os.write_plan',
        'os.read_plan',
        'os.ask_ceo',
    ],
    gates: [
        {
            tool: 'os.ask_ceo',
            owner: 'ceo',
            approval: 'specific',
        },
    ],
    spend: {
        moneyUsdPerRun: 1.5,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [
        {
            slug: 'task-create',
            on: 'ceo_approved',
            resumeConversation: true,
        },
        {
            slug: 'task-create',
            on: 'ceo_changes_requested',
        },
        {
            slug: 'task-self-improvement',
            on: 'terminal',
        },
    ],
    skillMd: TASK_TEXT['task-create.md'],
    adapterMd: TASK_TEXT['task-create.adapter.md'],
}
